(function(){
  'use strict';
  function qsa(selector, root){ return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  function serialize(form){
    var pairs = [];
    new FormData(form).forEach(function(value, key){
      value = String(value).trim();
      if(value !== '') pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    });
    return pairs.sort().join('&');
  }
  function init(root){
    if(root.__bcoNativeInit) return;
    root.__bcoNativeInit = true;

    var form = root.querySelector('form');
    if(!form) return;
    root.classList.add('is-enhanced');

    var apply = root.querySelector('[data-bco-native-apply]');
    var initial = serialize(form);
    function updateDirty(){
      var dirty = serialize(form) !== initial;
      if(apply){
        apply.hidden = !dirty;
        apply.disabled = !dirty;
      }
    }
    if(apply){
      apply.hidden = true;
      apply.disabled = true;
    }
    form.addEventListener('change', updateDirty);
    form.addEventListener('input', updateDirty);

    qsa('[data-bco-native-option-search]', root).forEach(function(input){
      input.addEventListener('input', function(){
        var term = input.value.trim().toLowerCase();
        var target = input.dataset.bcoNativeOptionSearch;
        qsa('[data-bco-native-options="' + target + '"] .bco-native-filter__option', root).forEach(function(row){
          row.hidden = !!term && row.textContent.toLowerCase().indexOf(term) === -1;
        });
      });
    });

    var desktop = window.matchMedia && window.matchMedia('(min-width: 1025px)').matches;
    if(desktop) qsa('details', root).forEach(function(details){ details.open = true; });
  }
  function boot(){ qsa('[data-bco-native-filter]').forEach(init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
